import React from "react";
import About from "./components/About";
import Contact from "./components/Contact";
import Experience from "./components/Experience";
import Navbar from "./components/Navbar";
import Projects from "./components/Projects";

export default function App() {
  return (
    <main className="bg-gray-950 text-gray-400 font-sans">
      <Navbar />
      <About />
      <Experience />
      <Projects />
      <Contact />
      <footer className="bg-gray-950 border-t border-gray-800 py-8">
        <div className="container mx-auto px-6 text-center text-sm text-gray-600">
          &copy; {new Date().getFullYear()} Daniel Coates
        </div>
      </footer>
    </main>
  );
}



// WEBPACK FOOTER //
// ./src/App.js